import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { getValueFromResource, dateFormatByAccountCulture } from '../../../common/timeLiveFunction';
import DatePicker from "react-datepicker";
import {
    updateAccountProjectTaskEmployeeAllocationHoursAsync, deleteAllocationHours, addAccountProjectTaskEmployeeAllocationHoursAsync, setValuesAllocationHours, setDatesAllocationHours, isEditableAllocationHoursList, getDataByAllocationHours
} from "../TaskSlice";
import { ShowToast } from '../../../common/Toastr';
import moment from "moment";
import { ShowSwal, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import '../Project.css'
import { format } from 'date-fns';
import PageSizeSelect from "../../../common/PageSizeSelect";
import CustomPagination from "../../../common/Pagination";
const objSortValues = {
    sortOrder: 'asc',
    sortColumn: 'ProjectName'
}

const ProjectTaskTeamAllocationHours = (props: any) => {
    const [searchTerm, setSearchTerm] = useState('');
    const { dateInsertionFormat, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, calendarStartDay } = useAppSelector(state => state.globalState);
    const { projectTaskTeamAllocationHoursList, isReloadTaskAllocationHours
    } = useAppSelector((state) => state.task);
    let expenseRowCount: number[] = [];
    let expenseMessage: string = "";
    const { t, oncloseModal,
        accountprojectId,
        accountprojecttaskid, 
        accountEmployeeId, 
        accountProjectTaskEmployeeId,
        selectedProjectName,
        selectedEmployeeName,
        selectedTaskName  } = props;
        
    const dispatch = useAppDispatch();
            const [pageSize, setPageSize] = useState(5);
                const [currentPage, setCurrentPage] = useState(1);
    const [projectTeam, setProjectTeam] = useState<any | ''>([]);
    useEffect(() => {
        dispatch(getDataByAllocationHours({ 
            accountProjectId: accountprojectId,
            accountProjectTaskId: accountprojecttaskid, 
            accountEmployeeId, 
            accountProjectTaskEmployeeId 
        }));

    }, [isReloadTaskAllocationHours, accountprojectId, accountprojecttaskid]);

    const handleSubmit = (values: any) => {
        oncloseModal();
    }

    const filteredData = projectTaskTeamAllocationHoursList.filter((item: any) => {
        const searchTermLowerCase = searchTerm.toLowerCase();
            // If EndDate is blank, include this row in filtered data

      // Always show blank row (ID 0) regardless of dates
  if (item.AccountProjectTaskEmployeeAllocationHoursId === 0) return true;
        return Object.values(item).some((value: any) => {
            if (typeof value === 'string') {
                return value.toLowerCase().includes(searchTermLowerCase);
            }
            return false;
        });
    });
//console.log("currentPage", currentPage)
//console.log("pageSize", pageSize)

console.log("filteredData", filteredData)
console.log("Original Data:", projectTaskTeamAllocationHoursList);

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    //console.log("indexOfFirstItem", indexOfFirstItem)
    //console.log("indexOfLastItem", indexOfLastItem)
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    //console.log("currentItems", currentItems)
    const totalItems = filteredData.length;
    //console.log("totalItems", totalItems)
    const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    }

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    }

    const handlePageSizeChange = (event: any) => {
        const { value } = event;
        setPageSize(Number(5));
        setCurrentPage(1);
    }

    const handleUpdateClick = (e: any, AccountProjectTaskEmployeeAllocationHoursId: number) => {
        const index = projectTaskTeamAllocationHoursList.findIndex((item: any) => item.AccountProjectTaskEmployeeAllocationHoursId === AccountProjectTaskEmployeeAllocationHoursId);
        const foundItem = projectTaskTeamAllocationHoursList[index];

        if(foundItem.AllocationHours === 0){
            ShowToast('Warning', 'Allocation hours cannot be blank.', "warning", "toast-top-right");
            //ShowSwal('PROJECT EMPLOYEE ALLOCATION', "Allocation hours cannot be zero.", "warning");
            return;
        }
        if(foundItem.StartDate === "" || foundItem.EndDate === null){
            ShowToast('Warning', 'Allocation hours cannot be blank.', "warning", "toast-top-right");
            //ShowSwal('PROJECT EMPLOYEE ALLOCATION', "Start Date cannot be blank.", "warning");
            return;
        }
        if(foundItem.EndDate === "" || foundItem.EndDate === null){
            ShowToast('Warning', 'End Date cannot be blank.', "warning", "toast-top-right");
            //ShowSwal('PROJECT EMPLOYEE ALLOCATION', "End Date cannot be blank.", "warning");
            return;
        }

    // Create a new object instead of mutating state directly
    const updatedItem = {
        ...projectTaskTeamAllocationHoursList[index],
        StartDate: moment(foundItem.StartDate).format(dateInsertionFormat),
        EndDate: moment(foundItem.EndDate).format(dateInsertionFormat),
        AllocationHours: Number(foundItem.AllocationHours), // Ensure it's a number,
        AccountProjectId: props.accountprojectid,
    };


        dispatch(updateAccountProjectTaskEmployeeAllocationHoursAsync(updatedItem))
            .unwrap()
            .then((originalPromiseResult) => {
                //setIsEdit(true);
                originalPromiseResult.StatusCode === "200" ?
                    ShowToast("Detail Update Successfully", 'Success', "success", "toast-top-right") :
                    ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
            })
            .catch((rejectedValueOrSerializedError) => {
                //setIsEdit(false);
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            })

    }

    const handleAddClick = () => {
        const index = projectTaskTeamAllocationHoursList.findIndex((item: any) => item.AccountProjectTaskEmployeeAllocationHoursId === 0);         
        const foundItem = projectTaskTeamAllocationHoursList[index];

        if(foundItem.AllocationHours === 0){
            ShowToast('Warning', 'Allocation hours cannot be zero.', "warning", "toast-top-right");
            //ShowSwal('PROJECT EMPLOYEE ALLOCATION', "Allocation hours cannot be zero.", "warning");
            return;
        }
        if(foundItem.StartDate === ""){
            ShowToast('Warning', 'Start Date cannot be blank.', "warning", "toast-top-right");
            //ShowSwal('PROJECT EMPLOYEE ALLOCATION', "Start Date cannot be blank.", "warning");
            return;
        }
        if(foundItem.EndDate === ""){
            ShowToast('Warning', 'End Date cannot be blank.', "warning", "toast-top-right");
            //ShowSwal('PROJECT EMPLOYEE ALLOCATION', "End Date cannot be blank.", "warning");
            return;
        }
            // Create a new object instead of mutating state directly
    const updatedItem = {
        ...projectTaskTeamAllocationHoursList[index],
        AccountProjectId: props.accountprojectid, // Ensure props is used,
        StartDate: moment(foundItem.StartDate).format(dateInsertionFormat),
        EndDate: moment(foundItem.EndDate).format(dateInsertionFormat),
        AllocationHours: Number(foundItem.AllocationHours), // Ensure it's a number,,
    };


        dispatch(addAccountProjectTaskEmployeeAllocationHoursAsync(updatedItem))
            .unwrap()
            .then((originalPromiseResult) => {
                //setIsEdit(true);
                originalPromiseResult.StatusCode === "200" ?
                    ShowToast("Detail Update Successfully", 'Success', "success", "toast-top-right") :
                    ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
            })
            .catch((rejectedValueOrSerializedError) => {
                //setIsEdit(false);
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            })

    }


    const handleAllocationHours = (e: any, AccountProjectTaskEmployeeAllocationHoursId: any) => {
        dispatch(setValuesAllocationHours({ "Id": AccountProjectTaskEmployeeAllocationHoursId, "AllocationHours": e.target.value }));
    };
    const removeProjectTaskTeamAllocationHoursList = (index: number, accountProjectTaskEmployeeAllocationHoursId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllocationHours(accountProjectTaskEmployeeAllocationHoursId))
                        .then((response) => {
                            //if (response?.payload?.length > 0 && response.payload.message) {
                            ShowToast('Success', response.payload.message, "success", "toast-top-right");
                            //} else {
                            //    ShowToast('Error', 'Unexpected response format', "error", "toast-top-right");
                            //}
                        })
                        .catch((error) => {
                            ShowToast('Error', 'Failed to delete record', "error", "toast-top-right");
                            console.error("Deletion error:", error);
                        });
                }
            })
            .catch((error) => {
                console.error("Swal confirmation error:", error);
            });
    };
    projectTaskTeamAllocationHoursList.map((item: any, index: number) => {
        if (item.ProjectName != null || item.AccountExpenseName != null || item.ExpenseType != null || item.Description != "") {
        } else {
            expenseRowCount.push(index);
            expenseMessage = "Please select either the project name, expense name, expense type, or description in the Expense Billing list for rows " + expenseRowCount.toString();
        }
    })


    const removeProjectTeamAllocationHoursList = (index: number, accountProjectTaskEmployeeAllocationHoursId: number) => {
        
    };


    const onDateChange = (date: any, name: any, accountProjectTaskEmployeeAllocationHoursId: number) => {
        const index = projectTaskTeamAllocationHoursList.findIndex((item: any) => item.AccountProjectTaskEmployeeAllocationHoursId === accountProjectTaskEmployeeAllocationHoursId);
        const foundItem = projectTaskTeamAllocationHoursList[index];
        
        if (name == "StartDate" && moment(date).format(dateInsertionFormat) > moment(foundItem.EndDate).format(dateInsertionFormat)) {
                    ShowToast('Error', t('Start date cannot be later than end date.'), "error", "toast-top-right");
                } else if (name == "EndDate" && moment(date).format(dateInsertionFormat) < moment(foundItem.StartDate).format(dateInsertionFormat)) {
                    ShowToast('Error', t('End date cannot be earlier than start date.'), "error", "toast-top-right");
                }else {
                                    name == "StartDate" ? dispatch(setDatesAllocationHours({ "Id": accountProjectTaskEmployeeAllocationHoursId, "StartDate": date })) 
                                    : 
                                    dispatch(setDatesAllocationHours({ "Id": accountProjectTaskEmployeeAllocationHoursId, "EndDate": date }));
                                }  


/*         if (name === "StartDate") {
            console.log("setDatesAllocationHours:", date);
            dispatch(setDatesAllocationHours({ "Id": accountProjectEmployeeAllocationHoursId, "StartDate": date }));
        } else {
            console.log("setDatesAllocationHours:", date);
            dispatch(setDatesAllocationHours({ "Id": accountProjectEmployeeAllocationHoursId, "EndDate": date }));
        }     */    
    }

    return (
        <>

                        <div className="modal drawer-overlay" style={{ display: 'block' }} >
                            <div className="modal-dialog" style={{ maxWidth: '45%' }}>
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                        <h5 className="modal-title mainHeading">

                                            {getValueFromResource('PROJECT TASK EMPLOYEE ALLOCATION HOURS', dispatch, t)}
                                        </h5>
                                        <div
                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                            //data-bs-dismiss="modal"
                                            onClick={oncloseModal}
                                        >
                                            <KTSVG
                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                className="svg-icon svg-icon-1x"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-body" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 230px)' }}>
                                <div className="row navBarParentDiv">
                                    <div className='col-md-4 col-sm-4 col-xs-12 projectTeamDetailInfo'>
                                        <div className='cardInfoShadow'>
                                            <div className='tsNavBarInnerBoxParent'>
                                                <div className='tsNavBarInnerBoxFirstSection'>
                                                    <div className='tsNavBarInnerBoxFirstInner' />
                                                    <div className='symbol symbol-48px me-3'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/customSVG/icon-Employee.svg')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='tsNavBarInnerBoxSecondSection'>
                                                    <span className="fw-bold d-block fs-6 tsNavBarInfoText">{selectedEmployeeName}</span>
                                                    <a className="text-uppercase tsNavBarInfoLabel">
                                                        {/* {t('Total Hours')} */}
                                                        {getValueFromResource('Employee',dispatch, t)}
                                                        </a>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    <div className='col-md-4 col-sm-4 col-xs-12 projectTeamDetailInfo'>
                                        <div className='cardInfoShadow'>
                                            <div className='tsNavBarInnerBoxParent'>
                                                <div className='tsNavBarInnerBoxFirstSection'>
                                                    <div className='tsNavBarInnerBoxFirstInner' />
                                                    <div className='symbol symbol-48px me-3'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/customSVG/icon-Date.svg')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='tsNavBarInnerBoxSecondSection'>
                                                    <span className="fw-bold d-block fs-6 tsNavBarInfoText">{selectedTaskName}</span>
                                                    <a className="text-uppercase tsNavBarInfoLabel">
                                                        {/* {t(`Department`)} */}
                                                        {getValueFromResource('TASK',dispatch, t)}
                                                        </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4 col-sm-4 col-xs-12 projectTeamDetailInfo'>
                                        <div className='cardInfoShadow'>
                                            <div className='tsNavBarInnerBoxParent'>
                                                <div className='tsNavBarInnerBoxFirstSection'>
                                                    <div className='tsNavBarInnerBoxFirstInner' />
                                                    <div className='symbol symbol-48px me-3'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/customSVG/icon-Shift.svg')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='tsNavBarInnerBoxSecondSection'>
                                                    <span className="fw-bold d-block fs-6 tsNavBarInfoText">{selectedProjectName}</span>
                                                    <a className="text-uppercase tsNavBarInfoLabel">
                                                        {/* {t(`SHIFT`)} */}
                                                        {getValueFromResource('PROJECT',dispatch, t)}
                                                        </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="card card-custom admin-card">
                                    <div className="card-header bg-white" style={{ padding: 0 }}>
                                        <h3 className="card-title fw-bold headerTitle">
                                            {/* {t(`Attendance`)} */}
                                            {/* {getValueFromResource('PROJECT TASK EMPLOYEE ALLOCATION HOURS',dispatch, t)} */}
                                            </h3>
                                        <div className="card-toolbar align-items-center">
                                            <div className="position-relative">

                                            </div>
                                            <div className='h-35px w-1px mx-1'></div>
                                           
                                            
                                            <div>
                                                {(currentItems.length > 0) ? (
                                                    <CustomPagination
                                                        currentPage={currentPage}
                                                        onPageChange={handlePageChange}
                                                        pageSize={pageSize}
                                                        totalItems={totalItems}
                                                        start={(currentPage - 1) * Number(pageSize)}
                                                        t={t}
                                                        //recordsFiltered={recordsFiltered}
                                                    >
                                                    </CustomPagination>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                        <div className='card-body py-3'>
                                            <div className='table-responsive' style={{ maxHeight: '670px', overflowY: 'auto' }}>
                                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr className='thHeading align-middle'>


                                                            <th style={{ width: '30%' }}
                                                                className='min-w-100px'
                                                            >
                                                                {getValueFromResource('Start Date', dispatch, t)}

                                                            </th>
                                                            <th style={{ width: '30%' }}
                                                            >
                                                                {getValueFromResource('End Date', dispatch, t)}

                                                            </th>
                                                            <th style={{ width: '30%' }}
                                                            >
                                                                {getValueFromResource('Allocation Hours', dispatch, t)}
                                                            </th>
                                                            <th className='min-w-100px'>
                                                                {/* {t("Action")} */}
                                                                {getValueFromResource('Action', dispatch, t)}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentItems.map((item: any, index: number) => {
                                                            return (
                                                                <tr style={{ height: 50 }}>

                                                                    <td>
                                                                        
                                                                        {item.AccountProjectTaskEmployeeAllocationHoursId === 0 || item.IsSelected || item.IsEditable ?
                                                                            <div className="wrapper">
                                                                                <DatePicker
                                                                                    selected={item.StartDate ? new Date(item.StartDate) : null}
                                                                                    onChange={(date) => onDateChange(date, "StartDate", item.AccountProjectTaskEmployeeAllocationHoursId)}
                                                                                    calendarStartDay={calendarStartDay}
                                                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                                                    className="form-control form-control-dark btn-icon-dark btn-text-dark inputFieldAlignment "
                                                                                >
                                                                                </DatePicker>
                                                                                <i className="insideField-Icons ki-outline ki-calendar text-gray me-10" ></i>
                                                                            </div> :
                                                                                <a className='text-gray-800 d-block'>
                                                                                    {/* {item.StartDate} */}
                                                                                    {moment.parseZone(dateFormatByAccountCulture(item.StartDate, cultureInfoName.toString())).format('DD MMM yy')}
                                                                                </a>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {item.AccountProjectTaskEmployeeAllocationHoursId === 0 || item.IsSelected || item.IsEditable ?
                                                                            <div className="wrapper">
                                                                                <DatePicker
                                                                                    selected={item.EndDate ? new Date(item.EndDate) : null}
                                                                                    onChange={(date) => onDateChange(date, "EndDate", item.AccountProjectTaskEmployeeAllocationHoursId)}
                                                                                    calendarStartDay={calendarStartDay}
                                                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                                                    className="form-control form-control-dark btn-icon-dark btn-text-dark inputFieldAlignment "
                                                                                >
                                                                                </DatePicker>
                                                                                <i className="insideField-Icons ki-outline ki-calendar text-gray me-10" ></i>
                                                                            </div> :
                                                                            <a className='text-gray-800 d-block'>
                                                                                {/* {item.EndDate} */}
                                                                                {moment.parseZone(dateFormatByAccountCulture(item.EndDate, cultureInfoName.toString())).format('DD MMM yy')}
                                                                            </a>
                                                                        }
                                                                    </td>
                                                                    <td>

                                                                        {item.AccountProjectTaskEmployeeAllocationHoursId === 0 || item.IsSelected || item.IsEditable ? 
                                                                        <input
                                                                            type="number"
                                                                            className="form-control inputFieldAlignment"
                                                                            name="AllocationHours"
                                                                            value={item.AllocationHours}
                                                                            onChange={(e) => handleAllocationHours(e, item.AccountProjectTaskEmployeeAllocationHoursId)}
                                                                            style={{ width: 110 }}
                                                                        /> : <a className='text-gray-800 d-block'>
                                                                            {item.AllocationHours}
                                                                        </a>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                    {item.AccountProjectTaskEmployeeAllocationHoursId === 0 ? (
    <span className="menu-icon custom-menu mb-2 cursor"
        onClick={() => handleAddClick()}
        data-tooltip-id="tooltip-Description"
        data-tooltip-content={getValueFromResource('Add', dispatch, t)}
        data-tooltip-place="top"
    >
        <i className="bi bi-plus-lg fs-6 iconColor"></i>
    </span>
) : (
    <>
                                                                        {!item.IsSelected && <>
                                                                            {!item.IsEditable && <span className="menu-icon custom-menu mb-2 cursor"
                                                                                onClick={() => { dispatch(isEditableAllocationHoursList(item.AccountProjectTaskEmployeeAllocationHoursId)) }}
                                                                                data-tooltip-id="tooltip-Description"
                                                                                data-tooltip-content=
                                                                                // {t("Editable")}
                                                                                {getValueFromResource('Editable', dispatch, t)}
                                                                                data-tooltip-place="top"
                                                                            >
                                                                                <i className="bi bi-pencil-square fs-6 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>}
                                                                            {item.IsEditable && <span className="menu-icon custom-menu mb-2 cursor"
                                                                                onClick={(e) => handleUpdateClick(e, item.AccountProjectTaskEmployeeAllocationHoursId)}
                                                                                data-tooltip-id="tooltip-Description"
                                                                                data-tooltip-content=
                                                                                // {t("Cancel")}
                                                                                {getValueFromResource('Cancel', dispatch, t)}
                                                                                data-tooltip-place="top"
                                                                            >
                                                                                <i className="bi bi-check-lg fs-2" style={{ color: '#26C281' }}></i>
                                                                            </span>}
                                                                        </>}
                                                                        <span className="menu-icon custom-menu mb-2 cursor"
                                                                            onClick={() => removeProjectTaskTeamAllocationHoursList(index, item.AccountProjectTaskEmployeeAllocationHoursId)}
                                                                            data-tooltip-id="tooltip-Description"
                                                                            data-tooltip-content=
                                                                            // {t("Delete")}
                                                                            {getValueFromResource('Delete', dispatch, t)}
                                                                            data-tooltip-place="top">
                                                                            <i className="bi bi-trash fs-6 iconColor allign">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                        </>
        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                                {currentItems.length === 0 &&
                                                    <div className=''>
                                                        <p className='noDataFound'>
                                                            {/* {t('No Record Found')} */}
                                                            {getValueFromResource('No Record Found', dispatch, t)}
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                            onClick={oncloseModal}
                                        >
                                            {/* {t('Cancel')} */}
                                            {getValueFromResource('Cancel', dispatch, t)}
                                        </button>
                                        
                                    </div>
                            </div>
                        </div></div>
                  
        </>
    )
}
export default ProjectTaskTeamAllocationHours;